const UPDATE_SUGGESTED_ATTENDEES = 'recurrenceMaster/UPDATE_SUGGESTED_ATTENDEES';
const UPDATE_SELECTED_ATTENDEES = 'recurrenceMaster/UPDATE_SELECTED_ATTENDEES';
const CLEAR_ATTENDEES = 'recurrenceMaster/CLEAR_ATTENDEES';
const SET_ATTENDEES_SEARCH_TERM = 'recurrenceMaster/SET_ATTENDEES_SEARCH_TERM';
const TOGGLE_ATTENDEES_LOADER = 'recurrenceMaster/TOGGLE_ATTENDEES_LOADER';

export default {
  UPDATE_SUGGESTED_ATTENDEES,
  UPDATE_SELECTED_ATTENDEES,
  CLEAR_ATTENDEES,
  SET_ATTENDEES_SEARCH_TERM,
  TOGGLE_ATTENDEES_LOADER
};
